import { Button } from "@/components/ui/button";
import { ShieldX } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function AccessDenied() {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-10rem)] px-4">
      <div className="flex flex-col items-center text-center max-w-md">
        <div className="flex items-center justify-center w-16 h-16 rounded-full bg-red-100 mb-5">
          <ShieldX className="h-8 w-8 text-red-600" />
        </div>
        <h1 className="text-xl font-bold text-gray-900 mb-2">Access denied</h1>
        <p className="text-sm text-gray-500 leading-relaxed mb-6">
          You do not have permission to access this page,<br />contact your admin.
        </p>
        <Button size="sm" variant="outline" onClick={() => navigate(-1)}>
          Go to previous page
        </Button>
      </div>
    </div>
  );
}
